// Persist an intent-to-save when the user is anonymous. After successful
// authentication the saved intent is executed so the user does not have to
// click "Save" again.
import { api } from "@/lib/api";
import { toast } from "sonner";

const KEY = "anokina_pending_save_material";

export function setPendingSave(materialId) {
  try { localStorage.setItem(KEY, materialId); } catch { /* noop */ }
}
export function getPendingSave() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
export function clearPendingSave() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
}

/**
 * Consume a pending "save" that was requested while anonymous.
 * Returns the material_id if executed, else null.
 * Safe to call after a successful login/registration.
 */
export async function runPendingSaveAfterAuth() {
  const mid = getPendingSave();
  if (!mid) return null;
  clearPendingSave();
  try {
    await api.post("/account/saved", { material_id: mid });
    toast.success("Материал сохранён в «Сохранённое»");
    return mid;
  } catch (_e) {
    // Material may have been unpublished — silently ignore.
    return null;
  }
}

